enum SignalRClientMethod {
  ReceiveChatMessage = "ReceiveChatMessage",
  ShouldRefetchActionItem = "ShouldRefetchActionItem",
  ShouldRefetchComments = "ShouldRefetchComments",
  ShouldRefetchAgendaItemContent = "ShouldRefetchAgendaItemContent",
  ShouldRefetchMeetingListItem = "ShouldRefetchMeetingListItem",
  ShouldRefetchMeetingNotes = "ShouldRefetchMeetingNotes",
  ShouldRefetchMeetingParticipants = "ShouldRefetchMeetingParticipants",
  ShouldRefetchTeamMeetingsList = "ShouldRefetchTeamMeetingsList",
  ShouldEndMeeting = "ShouldEndMeeting",
  ShouldRefetchPlan = "ShouldRefetchPlan",
  ShouldRefetchTeamIssues = "ShouldRefetchTeamIssues",
  ShouldRefetchUserIssues = "ShouldRefetchUserIssues",
  ShouldRefetchIssue = "ShouldRefetchIssue",
  ShouldRefetchNotifications = "ShouldRefetchNotifications",
  ShouldRefetchTaskItem = "ShouldRefetchTaskItem",
  ShouldRefetchTeamTaskItems = "ShouldRefetchTeamTaskItems",
  ShouldRefetchUserTaskItems = "ShouldRefetchUserTaskItems",
  ShouldRefetchUserStrategicOwnershipItems = "ShouldRefetchUserStrategicOwnershipItems",
  RefetchActiveMeetingNotifications = "RefetchActiveMeetingNotifications",
  ShouldUpdateFormSubmissions = "ShouldUpdateFormSubmissions",
  ShouldUpdateFormSubmissionDetail = "ShouldUpdateFormSubmissionDetail",
}

enum SignalRServerMethod {
  JoinGroup = "JoinGroup",
  JoinGroups = "JoinGroups",
  LeaveGroup = "LeaveGroup",
  LeaveGroups = "LeaveGroups",
  SendChatMessage = "SendChatMessage",
  SendRefetchActionItem = "SendRefetchActionItem",
  SendRefetchComments = "SendRefetchComments",
  SendRefetchAgendaItemContent = "SendRefetchAgendaItemContent",
  SendRefetchMeetingListItem = "SendRefetchMeetingListItem",
  SendRefetchMeetingNotes = "SendRefetchMeetingNotes",
  SendRefetchMeetingParticipants = "SendRefetchMeetingParticipants",
  SendRefetchTeamMeetingsList = "SendRefetchTeamMeetingsList",
  SendEndMeeting = "SendEndMeeting",
  SendRefetchPlan = "SendRefetchPlan",
  SendRefetchTeamIssues = "SendRefetchTeamIssues",
  SendRefetchUserIssues = "SendRefetchUserIssues",
  SendRefetchIssue = "SendRefetchIssue",
  SendRefetchNotifications = "SendRefetchNotifications",
  SendRefetchTaskItem = "SendRefetchTaskItem",
  SendRefetchTeamTaskItems = "SendRefetchTeamTaskItems",
  SendRefetchUserTaskItems = "SendRefetchUserTaskItems",
  SendRefetchUserStrategicOwnershipItems = "SendRefetchUserStrategicOwnershipItems",
  SendUpdateFormSubmissions = "SendUpdateFormSubmissions",
  SendUpdateFormSubmissionDetail = "SendUpdateFormSubmissionDetail",
}

const SignalRGroup = {
  ActionItem: (actionItemGuid: string) => `ActionItem-${actionItemGuid}`,
  CommentThread: (threadGuid: string) => `CommentThread-${threadGuid}`,
  Meeting: (meetingGuid: string) => `Meeting-${meetingGuid}`,
  TeamMeetings: (teamGuid: string) => `TeamMeetings-${teamGuid}`,
  MeetingAgendaItemContent: (agendaItemGuid: string) => `MeetingAgendaItemContent-${agendaItemGuid}`,
  MeetingNotes: (meetingGuid: string) => `MeetingNotes-${meetingGuid}`,
  MeetingListItem: (meetingGuid: string) => `MeetingListItem-${meetingGuid}`,
  Plan: (planGuid: string) => `Plan-${planGuid}`,
  TeamIssues: (teamSlug: string) => `TeamIssues-${teamSlug}`,
  UserIssues: (userGuid: string) => `UserIssues-${userGuid}`,
  Issue: (issueGuid: string) => `Issue-${issueGuid}`,
  Notifications: (userId: string) => `Notifications-${userId}`,
  TaskItem: (taskItemGuid: string) => `TaskItem-${taskItemGuid}`,
  TeamTaskItems: () => `TeamTaskItems`,
  UserTaskItems: (userGuid: string) => `UserTaskItems-${userGuid}`,
  UserStrategicOwnershipItems: (userGuid: string) => `UserStrategicOwnershipItems-${userGuid}`,
  MeetingNotificationsForUser: (userGuid: string) => `MeetingNotifications-${userGuid}`,
  FormSubmissions: () => `FormSubmissions`,
  FormSubmissionDetail: (formSubmissionGuid: string) => `FormSubmissionDetail-${formSubmissionGuid}`,
};

export { SignalRClientMethod, SignalRGroup, SignalRServerMethod };
